/**
 * Pure helpers for calculator experience selection by strain count.
 * Kept free of React so transitions can be unit-tested.
 */

export type CalculatorExperience = 'empty' | 'single' | 'blend';

/** Practical UI cap — engine supports N but search is combinatorially bounded. */
export const CALCULATOR_MAX_STRAINS = 4;

export function calculatorExperience(selectedCount: number): CalculatorExperience {
  if (selectedCount <= 0) return 'empty';
  if (selectedCount === 1) return 'single';
  return 'blend';
}

/** Add a strain ID if not already selected and under the max. */
export function addSelectedStrainId(
  selectedIds: readonly string[],
  strainId: string,
  max = CALCULATOR_MAX_STRAINS,
): string[] {
  if (selectedIds.includes(strainId)) return [...selectedIds];
  if (selectedIds.length >= max) return [...selectedIds];
  return [...selectedIds, strainId];
}

/** Remove a strain ID; preserves relative order of remaining. */
export function removeSelectedStrainId(
  selectedIds: readonly string[],
  strainId: string,
): string[] {
  return selectedIds.filter((id) => id !== strainId);
}

export function canAddAnotherStrain(
  selectedIds: readonly string[],
  max = CALCULATOR_MAX_STRAINS,
): boolean {
  return selectedIds.length > 0 && selectedIds.length < max;
}
